import {__} from '@vo/js/utils/i18n'

export default (function () {
    const inputs = document.querySelectorAll('[data-algolia-search]')
    if (!inputs.length) return

    inputs.forEach(input => {
        const wrapper = input.closest('[data-algolia-search-wrapper]')
        const resultsWrapper = wrapper?.querySelector('[data-algolia-results-wrapper]')
        const resultsContainer = wrapper?.querySelector('[data-algolia-results]')

        if (!resultsWrapper || !resultsContainer) return

        let debounceTimeout = null

        const showResults = () => {
            resultsWrapper.classList.remove('hidden')
        }
        const hideResults = () => {
            resultsWrapper.classList.add('hidden')
            resultsContainer.innerHTML = ''
        }

        const showMessage = (text) => {
            resultsContainer.innerHTML = ''
            const item = document.createElement('li')
            item.className = 'p-4'
            item.textContent = text
            resultsContainer.appendChild(item)
            showResults()
        }

        const fetchResults = async (query, siteHandle) => {
            if (!query) {
                hideResults()
                return
            }

            try {
                const response = await fetch(`/api/algolia-search/${siteHandle}`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ query })
                })
                const data = await response.json()
                renderResults(data.hits)
            } catch (error) {
                console.error('Search error:', error)
                showMessage(__('Something went wrong. Please try again.'))
            }
        }

        const renderResults = (hits) => {
            resultsContainer.innerHTML = ''

            if (!hits || !hits.length) {
                showMessage(__('No results matching your query have been found.'))
                return
            }

            hits.forEach(hit => {
                const li = document.createElement('li')
                li.className = 'py-4 border-b border-gray-light first:pt-0 last:pb-0 first:border-t-0 last:border-b-0'

                let image = ''
                if (hit.image) {
                    image = `<div class="shrink-0 overflow-hidden h-16 w-16">
                        <img src="${hit.image}" alt="" class="h-full w-full object-cover transition-transform duration-300 group-hover/search-item:scale-110">
                    </div>`
                }

                li.innerHTML = `
                    <a href="${hit.url}" class="flex gap-2.5 group/search-item">
                        ${image}
                        <div class="grow space-y-2">
                            <strong class="text-black line-clamp-1 transition-colors duration-300 group-hover/search-item:text-blue">${hit.headline || hit.title || hit.name}</strong>
                            <p class="line-clamp-2">${hit.description || ''}</p>
                        </div>
                    </a>
                `
                resultsContainer.appendChild(li)
            })

            showResults()
        }

        input.addEventListener('input', (e) => {
            const query = e.target.value.trim()
            const siteHandle = e.target.dataset.site

            clearTimeout(debounceTimeout)
            debounceTimeout = setTimeout(() => fetchResults(query, siteHandle), 300)
        })

        document.addEventListener('click', (e) => {
            if (!wrapper.contains(e.target)) {
                hideResults()
            }
        })
    })
})
